import { render, staticRenderFns } from "./FreeSubmission.vue?vue&type=template&id=c51a5dce&scoped=true"
import script from "./FreeSubmission.vue?vue&type=script&lang=js"
export * from "./FreeSubmission.vue?vue&type=script&lang=js"
import style0 from "./FreeSubmission.vue?vue&type=style&index=0&id=c51a5dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a5dce",
  null
  
)

export default component.exports